module.exports = __webpack_public_path__ + "img/banner.d84d805a.jpg";